import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHelperService } from '../../shared/services/http-helper.service';
import { Observable, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    protected baseUrl = environment.apiUrl;

    constructor(private httpClient: HttpClient, private httpHelperService: HttpHelperService) {}

    public uploadAttachment(id: string, prefix: string, file: File): Observable<void> {
        const filename = `${prefix}/${file.name}`;
        return this.httpClient
            .get<{ signedURL: string }>(
                `${environment.apiUrl}/cod-attachments/${id}/${encodeURIComponent(filename)}/links/upload`,
                {
                    headers: { 'Content-Type': file.type },
                    params: { contentType: file.type, contentLength: file.size }
                }
            )
            .pipe(
                switchMap(({ signedURL }: { signedURL: string }) =>
                    this.httpClient.put<void>(signedURL, file, { headers: { 'Content-Type': file.type } })
                ),
                this.httpHelperService.handleError('Cannot upload attachment')
            );
    }

    public copyAttachment(sourceKey: string, destinstaion: string): Observable<void> {
        return this.httpClient
            .post<void>(`${environment.apiUrl}/cod-attachments/copy`, { sourceKey, destinstaion })
            .pipe(this.httpHelperService.handleError('Cannot copy attachment'));
    }

    public getAttachments(id: string): Observable<{ Key: string }[]> {
        return this.httpClient
            .get<{ Key: string }[]>(`${environment.apiUrl}/cod-attachments/${id}/`)
            .pipe(this.httpHelperService.handleError('Cannot fetch attachments'));
    }

    public downloadAttachment(id: string, key: string): Observable<{ signedURL: string }> {
        return this.httpClient
            .get<{ signedURL: string }>(`${environment.apiUrl}/cod-attachments/${id}/${key}/links/download`)
            .pipe(
                tap(({ signedURL }: { signedURL: string }) => {
                    const link = document.createElement('a');
                    link.href = signedURL;
                    link.download = key;
                    link.click();

                    URL.revokeObjectURL(signedURL);
                    link.remove();
                }),
                this.httpHelperService.handleError('Cannot download attachment')
            );
    }
}
